const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const sportsbettings = (state = initialState, action) => {
	switch (action.type) {
		case 'SBBT_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SBBT_ADD_DATA':
			const addDatas = [...state.data, action.data]
			return Object.assign({ ...state, data: addDatas, total: state.total + 1 })
		case 'SBBT_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const upateData = state.data
			upateData[index] = action.data
			return Object.assign({ ...state, data: [...upateData] })
		case 'SBBT_DEL_DATA':
			const data = state.data.filter((e) => e.id !== action.index)
			return { ...state, data, total: state.total - 1 }
		case 'SBBT_GET_CURRENT':
			return { ...state, selected: action.selected }
		case 'SBBT_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default sportsbettings
